import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource-variable/inter";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./contexts/UserContext";
import { HelmetProvider } from "react-helmet-async";
import { analytics } from "./firebase";
import { logEvent } from "firebase/analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </UserProvider>
  </React.StrictMode>
);

// Send real Core Web Vitals to Firebase Analytics so performance regressions
// are actually visible, instead of being measured and silently discarded.
reportWebVitals(({ name, value, id }) => {
  if (!analytics) return;
  logEvent(analytics, "web_vitals", {
    metric_name: name,
    metric_value: Math.round(name === "CLS" ? value * 1000 : value),
    metric_id: id,
  });
});
